/* eslint-disable no-dupe-keys */
<template>
  <div class="d-flex col-12 col-md-4 mb-3">
    <div class="card mx-1">
      <!-- Image Cap -->
      <img
        v-if="image != null"
        :src="image.url"
        :alt="image.caption"
        class="card-img-top img-responsive"
        style="height: 200px;"
      />

      <svg
        v-if="image == null"
        class="card-img-top img-responsive"
        width="100%"
        height="200"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid slice"
        focusable="false"
        role="img"
        aria-label="Placeholder: Image unavailable"
      >
        <title>Placeholder</title>
        <rect width="100%" height="100%" fill="#868e96"></rect>
        <text x="50%" y="50%" fill="#dee2e6" dy="1em">Image unavailable</text>
      </svg>

      <!-- Header -->
      <h5 class="card-header">{{ header }}</h5>

      <!-- Card Body -->
      <div class="card-body">
        <div class="row border-bottom">
          <div class="col">
            <h6 class="card-title">{{ location }}</h6>
          </div>
          <div class="col">
            <div class="row">
              <div class="col d-flex flex-row-reverse">
                <span
                  v-if="icons.length == 0 && product.rating != ''"
                  class="badge badge-info mt-n2 pt-2 pb-1 px-2"
                  :aria-label="product.rating"
                  >{{ product.rating }}</span
                >
                <font-awesome-icon
                  v-for="(icon, index) in icons"
                  :key="index"
                  :icon="icon"
                  style="color: #FFD700;"
                  :aria-label="product.rating"
                />
              </div>
            </div>
          </div>
        </div>
        <p class="card-text mt-2">{{ description }}</p>
      </div>

      <!-- Card Footer -->
      <div class="card-footer">
        <div
          v-if="product.productType.productTypeCode == 'REST'"
          class="input-group justify-content-between align-items-center"
        >
          <font-awesome-icon
            class="fa-lg"
            icon="clock"
            aria-label="Reservation time"
          />
          <button
            v-for="restaurantTime in restaurantTimes"
            :key="restaurantTime"
            class="btn btn-sm btn-success"
            @click="addButtonClicked(product.productId, restaurantTime)"
          >
            {{ restaurantTime }}
          </button>
        </div>
        <div
          v-if="product.productType.productTypeCode != 'REST'"
          class="input-group justify-content-end"
        >
          <button
            class="btn btn-success right"
            @click="addButtonClicked(product.productId)"
          >
            Add {{ productType }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { eventBus } from '../../../main.js'
import { mapState } from 'vuex'
import { faStar, faEuroSign } from '@fortawesome/free-solid-svg-icons'

const starRegex = /^\d\sStar/g

export default {
  props: {
    product: { type: Object, required: true },
    productType: { type: String, required: true }
  },
  data() {
    return {
      icons: []
    }
  },
  computed: {
    ...mapState({ restaurantTimes: state => state.dayByDay.restaurantTimes }),
    header() {
      return this.product.title
    },
    location() {
      return this.product.fromCity.name
    },
    description() {
      return this.product.description
    },
    image() {
      if (this.product.images.length > 0 && this.product.images[0].url !== '') {
        return this.product.images[0]
      }
      return null
    }
  },
  methods: {
    addButtonClicked(productId) {
      eventBus.addProduct(productId)
    },
    // eslint-disable-next-line no-dupe-keys
    // eslint-disable-next-line vue/no-dupe-keys
    addButtonClicked(productId, productTime) {
      eventBus.addProduct(productId, productTime)
    }
  },
  created() {
    if (this.product.productType.productTypeCode === 'HTL') {
      if (this.product.rating.match(starRegex)) {
        for (
          let i = 0;
          i < parseInt(this.product.rating.substring(0, 1));
          i++
        ) {
          this.icons.push(faStar)
        }
      }
    } else if (
      this.product.productType.productTypeCode === 'EXCR' ||
      this.productType.productTypeCode === 'TRA'
    ) {
      let repeats = 0
      if (this.product.rating === 'Premium') {
        repeats = 3
      } else if (this.product.rating === 'Standard') {
        repeats = 2
      } else if (this.product.rating === 'Economy') {
        repeats = 1
      }

      for (let i = 0; i < repeats; i++) {
        this.icons.push(faEuroSign)
      }
    }
  }
}
</script>
